var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleWorkNow)?_c('div',{staticClass:"top-entity-component__parameter"},[_c('Icon24FillClock',{staticClass:"top-entity-component__parameter-icon"}),_vm._v(" "),_c('WorkTime',{attrs:{"work-hours":_vm.workHours}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }